import React, {Fragment} from "react";
import {Box} from "@mui/material";
import LoadingPlaceholderBlock from "../../../../common/LoadingPlaceholderBlock";

export default function ConversionEmptyState() {
    return (
        <Fragment>
            <Box sx={{marginBottom: '20px'}}>
                <LoadingPlaceholderBlock
                    width={"100%"}
                    height={'100px'}
                    borderRadius={'6px'}
                    backgroundColor={'#EFEAE5'}
                />
            </Box>
            <Box sx={{marginBottom: '10px'}}>
                <LoadingPlaceholderBlock
                    width={"100px"}
                    height={'22px'}
                    borderRadius={'6px'}
                    backgroundColor={'#EFEAE5'}
                />
            </Box>
            <Box>
                {[...new Array(5)].map((item, index) => {
                    return (
                        <Box mb={'14px'} key={index}>
                            <LoadingPlaceholderBlock
                                key={item}
                                width={"100%"}
                                height={'81px'}
                                borderRadius={'6px'}
                                backgroundColor={'#EFEAE5'}
                            />
                        </Box>
                    )
                })}
            </Box>
        </Fragment>
    )
}